export default {
  __name: 'Layout',
  setup: function setup(__props) {
    return {
      __sfc: true
    };
  }
};